import React from 'react';
import type { DropdownIndicatorProps } from 'react-select';
import { components } from 'react-select';

// this overrides the default dropdown arrow
const DropdownIndicator = <Option,>(props: DropdownIndicatorProps<Option, boolean>) => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <i translate="no" className="material-symbols-outlined caret-icon">
                    expand_more
                </i>
            </components.DropdownIndicator>
        )
    );
};

export default DropdownIndicator;
